import { render, staticRenderFns } from "./DocumentSettingsCommon.vue?vue&type=template&id=24ba3509&scoped=true"
import script from "./DocumentSettingsCommon.vue?vue&type=script&lang=js"
export * from "./DocumentSettingsCommon.vue?vue&type=script&lang=js"
import style0 from "./DocumentSettingsCommon.vue?vue&type=style&index=0&id=24ba3509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba3509",
  null
  
)

export default component.exports